import ColorCore from './core/index.es.js';

const DEFAULT_WEIGHT = 5;
const valueOptions = {
  50: 1,
  100: 2,
  200: 4,
  500: 20,
  600: 22,
  700: 24
};
function generate(color, type) {
  const patterns = { [type]: color };
  const pColors = new ColorCore(color).all(DEFAULT_WEIGHT);
  Object.keys(valueOptions).forEach((key) => {
    patterns[`${type}${key}`] = pColors[valueOptions[key]].hexString();
  });
  return patterns;
}

export { generate as default };
